import FlowEnum from '../../../types/FlowEnum';
import { useGlobalState } from '../../../state/persistence';

const useSetFlow = (flow: FlowEnum | null = null) => {
  const { appStore, dispatchAppStore } = useGlobalState();

  if (appStore.flow !== flow) {
    dispatchAppStore('flow', flow);
  }
};

export default useSetFlow;
